module.exports = __webpack_public_path__ + "static/clear-success.7d782470.png";